import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

export const GetMarketIntelReportPdfUrlRequestDtoSchema = z.object({
  facilityId: z.number(),
  comparisonSet: z.enum(['INTERNAL', 'COMP']),
  from: z.string(),
  to: z.string(),
});

export const GetMarketIntelReportPdfUrlResponseDtoSchema = z.object({
  reportUrl: z.string().url(),
});

export type GetMarketIntelReportPdfUrlRequestDto = z.infer<
  typeof GetMarketIntelReportPdfUrlRequestDtoSchema
>;
export type GetMarketIntelReportPdfUrlResponseDto = z.infer<
  typeof GetMarketIntelReportPdfUrlResponseDtoSchema
>;

export const getMarketIntelReportPdfUrl = (
  params: GetMarketIntelReportPdfUrlRequestDto,
  config?: AxiosRequestConfig<GetMarketIntelReportPdfUrlRequestDto>
) => {
  return api
    .get('/market-intel-subscription/report-pdf', {
      params,
      ...config,
    })
    .then(responseContract(GetMarketIntelReportPdfUrlResponseDtoSchema));
};
